module.exports = __webpack_public_path__ + "img/shrimp-mobile.cad58986.png";